import BaseService from './baseService';

class PaymentMethods extends BaseService {
	async getPaymentMethods(opts = {}) {
    this.endPoint = '/payment-methods';
		return this.get(opts);
  }
  async getListPaymentMethods(params, opts = {}) {
    this.endPoint = `/payment-methods?type=${params}`;
    return this.get(opts)
  }
  async createPaymentMethods(payload){
    this.endPoint = '/payment-methods';
    return await this.post(payload); 
  }
  async filterPaymentMethod(payload){
    this.endPoint = '/payment-methods/filterPaymentMethod';
    return await this.post(payload); 
  }
  async updatePaymentMethods(id,payload,opts={}){
    this.endPoint = '/payment-methods';
    return await this.putOne(id,payload,opts);
  }
  async deletePaymentMethods(id,opts={}){
    this.endPoint = '/payment-methods';
    return await this.delete(id,opts);
  }
}

export default new PaymentMethods();